import React from "react";
import "./TagCloud.css";

const TagCloud = () => {
  return (
    <div className="whatsNew container--full">
      {/* <h3>Tag cloud</h3> */}
      <div className='container'>
        <div className="whatsNew-cloud">
          <p className="item-1">Backend for frontend</p> 
          <p className="item-2">Declarable</p> 
          <p className="item-3">Microfrontend revolution</p> 
          <p className="item-4">RxJS</p> 
          <p className="item-5">Attribute directives</p> 
          <p className="item-6">GIT</p> 
          <p className="item-7">Dependency injection</p> 
          <p className="item-8">Angular tests</p> 
          <p className="item-9">Cypress</p> 
          <p className="item-10">Microfrontend revolution</p> 
          <p className="item-11">ng module</p> 
          <p className="item-12">Binding</p> 
          <p className="item-13">IVY</p> 
          <p className="item-14">DSL</p>
          <p className="item-15">Jx</p>
        </div>
      </div>
    </div>
  );
};
export default TagCloud;
